var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { v4 as uuid } from 'uuid';
import { action, set, computed } from '@ember/object';
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { Currency, Money } from '@square/dashboard-protos/models/squareup/connect/v2/common/money';
import { Account, Category, SavingsAccountMetadata } from '@square/dashboard-protos/models/squareup/banking/account_model';
import { WithholdingConfig } from '@square/dashboard-protos/models/squareup/banking/withholding_config_model';
import { TAX_DEFAULT_WITHHOLDING_BPS, DEFAULT_WITHHOLDING_BPS, MAX_WITHHOLDING_BPS, MIN_WITHHOLDING_BPS, RAINY_DAY_DEFAULT_WITHHOLDING_BPS, MAX_TARGET_AMOUNT } from '@banking/ui/utils/constants';
import { getLabelForMerchantBusinessCategory } from '@banking/api/utils/bank-account';
import { CreateWithholdingConfigRequest, UpdateWithholdingConfigRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/dashboardweb/withholding_config/withholding_config_request_response';
import { WithholdingConfig as BBFrontendWithholdingConfig } from '@square/dashboard-protos/models/squareup/bbfrontend/dashboardweb/withholding_config/withholding_config';
import { AccountScopedIdentifier } from '@square/dashboard-protos/models/squareup/bbfrontend/common/identifier/account_scoped_identifier';
import { AccountMetadata, AccountType, FoldersAccountMetadata } from '@square/dashboard-protos/models/squareup/bbfrontend/dashboardweb/account/account';
import { isMerchantWithholding, isUnitWithholding, getMostRecentConfigs } from '@banking/api/utils/unified-account';
// Manage automation and subaccount state during create and edit flows
let AutomationSubaccountState = (_dec = service('bbfrontend/v1/account'), _dec2 = service('bbfrontend/v1/withholding-config'), _dec3 = service('smart-folder-recommendation'), _dec4 = computed('_currentMaxBps', 'accountId', 'bankingWithholdingConfigApi.withholdingConfigs', 'bbFrontendV1WithholdingConfigService.accountWithholdingConfigs', 'foldersAccounts.accounts', 'locationSelector.units', 'maxBps', 'savingsAccounts.openAccountIds', 'totalUnitBpsMap.size', 'unitTokenToTotalBpsMap.size'), _dec5 = computed('accountName', 'foldersAccounts.openAccountNames', 'savingsAccounts.openAccountNames'), _dec6 = computed('accountName'), _dec7 = computed('accountName'), _dec8 = computed('unitWithholdingConfigs'), _dec9 = computed('locationSelector.units'), _dec10 = computed('activeUnits.length'), _dec11 = computed('applyBpsToAllLocations', 'unitWithholdingConfigs', 'withholdingBps'), _dec12 = computed('activeUnits', 'bbFrontendV1WithholdingConfigService.accountWithholdingConfigs', 'foldersAccounts.openFoldersAccounts', 'accountId'), _dec13 = computed('applyBpsToAllLocations', 'maxBps', 'unitTokenToTotalBpsMap', 'unitWithholdingConfigs'), _dec14 = computed('applyBpsToAllLocations', 'currentMaxBps', 'invalidBpsUnit', 'minBps', 'withholdingBps'), _dec15 = computed('category', 'smartFolderRecommendationService.recommendedSmartFolders'), _dec16 = computed('smartFolderRecommendationService.merchantCategory'), _class = class AutomationSubaccountState extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "bankingAccountApi", _descriptor, this);
    _initializerDefineProperty(this, "bankingWithholdingConfigApi", _descriptor2, this);
    _initializerDefineProperty(this, "bbFrontendV1AccountService", _descriptor3, this);
    _initializerDefineProperty(this, "bbFrontendV1WithholdingConfigService", _descriptor4, this);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor5, this);
    _initializerDefineProperty(this, "features", _descriptor6, this);
    _initializerDefineProperty(this, "intl", _descriptor7, this);
    _initializerDefineProperty(this, "locationSelector", _descriptor8, this);
    _initializerDefineProperty(this, "foldersAccounts", _descriptor9, this);
    _initializerDefineProperty(this, "savingsAccounts", _descriptor10, this);
    _initializerDefineProperty(this, "sfsAccountApi", _descriptor11, this);
    _initializerDefineProperty(this, "sfsCustomerApi", _descriptor12, this);
    _initializerDefineProperty(this, "smartFolderRecommendationService", _descriptor13, this);
    _initializerDefineProperty(this, "userInfo", _descriptor14, this);
    _initializerDefineProperty(this, "accountName", _descriptor15, this);
    _initializerDefineProperty(this, "accountId", _descriptor16, this);
    _initializerDefineProperty(this, "category", _descriptor17, this);
    _initializerDefineProperty(this, "idempotencyKey", _descriptor18, this);
    _initializerDefineProperty(this, "maxBps", _descriptor19, this);
    _initializerDefineProperty(this, "minBps", _descriptor20, this);
    _initializerDefineProperty(this, "shouldAutomationToggleBeOn", _descriptor21, this);
    _initializerDefineProperty(this, "targetAmount", _descriptor22, this);
    _initializerDefineProperty(this, "maxTargetAmount", _descriptor23, this);
    _initializerDefineProperty(this, "withholdingBps", _descriptor24, this);
    // Used to determine whether to create a new config
    _initializerDefineProperty(this, "currentConfigCompleted", _descriptor25, this);
    _initializerDefineProperty(this, "applyBpsToAllLocations", _descriptor26, this);
    _initializerDefineProperty(this, "unitWithholdingConfigs", _descriptor27, this);
    _defineProperty(this, "_currentMaxBps", void 0);
  }
  get currentMaxBps() {
    if (this._currentMaxBps !== undefined) {
      return this._currentMaxBps;
    }
    const currentMaxBps = this.bankingWithholdingConfigApi.withholdingConfigs.reduce((current, config) => {
      const open = this.savingsAccounts.openAccountIds.includes(config.accountId);
      return config.enabled && open && config.accountId !== this.accountId ? current - config.withholdingBps : current;
    }, this.maxBps);
    const maxTotalUnitBps = this.unitTokenToTotalBpsMap.size > 0 ? Math.max(...this.unitTokenToTotalBpsMap.values()) : 0;
    return currentMaxBps - maxTotalUnitBps;
  }
  set currentMaxBps(value) {
    set(this, '_currentMaxBps', value);
  }
  get showDuplicateNameError() {
    return [...this.savingsAccounts.openAccountNames, ...this.foldersAccounts.openAccountNames].includes(this.accountName.toLowerCase());
  }
  get showBlankNameError() {
    return this.accountName.trim() === '';
  }
  get showInvalidNameError() {
    return !/^[\dA-Za-z]+/.test(this.accountName);
  }
  get enabledUnitWithholdingConfigs() {
    return this.unitWithholdingConfigs.filter(config => config.isEnabled && config.withholdingBps);
  }
  get activeUnits() {
    return this.locationSelector.units?.filter(unit => unit.unitActive) || [];
  }
  get canSetMultiUnitWithholdingConfig() {
    return this.features.isEnabled('banking/access_unified_folders') && this.activeUnits.length > 1;
  }
  get hasSetWithholdingBps() {
    if (this.applyBpsToAllLocations) {
      return Boolean(this.withholdingBps);
    } else {
      return this.unitWithholdingConfigs.some(config => config.isEnabled && config.withholdingBps);
    }
  }
  get unitTokenToTotalBpsMap() {
    const accountWithholdingConfigs = this.bbFrontendV1WithholdingConfigService.accountWithholdingConfigs;
    // key: unitToken, value: totalBps
    const unitTokenToTotalBpsMap = new Map();
    this.activeUnits.forEach(unit => unitTokenToTotalBpsMap.set(unit.token, 0));
    let totalMerchantBps = 0;
    for (const accountConfig of accountWithholdingConfigs) {
      // In edit flow, exclude edited account's withholding configs from total bps calculation
      if (accountConfig.accountId === this.accountId) {
        continue;
      }
      // If withholding config is for a closed account, don't include it in calculations
      if (!this.foldersAccounts.openFoldersAccounts.some(a => a.id === accountConfig.accountId)) {
        continue;
      }
      for (const config of accountConfig.withholdingConfigs) {
        if (!config.owner) {
          throw new Error('Each account withholding config must have an owner');
        }
        if (!config.isEnabled) {
          continue;
        }
        const owner = config.owner;
        if (owner.type === AccountScopedIdentifier.TokenType.TOKEN_TYPE_MERCHANT) {
          totalMerchantBps += config.withholdingBps;
        } else if (owner.type === AccountScopedIdentifier.TokenType.TOKEN_TYPE_UNIT) {
          const existingTotalUnitBps = unitTokenToTotalBpsMap.get(owner.token);
          unitTokenToTotalBpsMap.set(owner.token, config.withholdingBps + (existingTotalUnitBps || 0));
        }
      }
    }

    // Merchant level bps is applied to all units
    for (const [unitToken, totalBps] of unitTokenToTotalBpsMap) {
      unitTokenToTotalBpsMap.set(unitToken, totalBps + totalMerchantBps);
    }
    return unitTokenToTotalBpsMap;
  }
  get invalidBpsUnit() {
    if (this.applyBpsToAllLocations) {
      return undefined;
    }
    const unitTokenToTotalBpsMap = this.unitTokenToTotalBpsMap;
    const maxBps = this.maxBps;
    for (const unitWithholding of this.unitWithholdingConfigs) {
      const withholdingBps = unitWithholding.withholdingBps;
      if (!withholdingBps || !unitWithholding.isEnabled) {
        continue;
      }
      // bps from other accounts for the unit + currently edited account bps for the unit
      const totalUnitBps = unitTokenToTotalBpsMap.get(unitWithholding.unitToken) || 0;
      if (totalUnitBps + withholdingBps > maxBps) {
        return {
          token: unitWithholding.unitToken,
          remainingBps: maxBps - totalUnitBps
        };
      }
    }
    return undefined;
  }
  get isWithholdingConfigValid() {
    if (this.applyBpsToAllLocations) {
      const bps = this.withholdingBps || 0;
      return bps >= this.minBps && bps <= this.currentMaxBps;
    } else {
      return Boolean(this.invalidBpsUnit) === false;
    }
  }
  get smartFolderRecommendation() {
    return this.smartFolderRecommendationService.recommendedSmartFolders.find(folder => folder.category === this.category);
  }
  get merchantCategoryString() {
    return this.intl.t(getLabelForMerchantBusinessCategory(this.smartFolderRecommendationService.merchantCategory)).toLowerCase();
  }
  toggleCreateAutomation() {
    set(this, 'shouldAutomationToggleBeOn', !this.shouldAutomationToggleBeOn);
  }
  setName(name) {
    set(this, 'accountName', name);
  }
  updateName(event) {
    const input = event.target;
    set(this, 'accountName', input.value);
  }
  updateUnitWithholding(unitToken, updates) {
    const updatedUnitWithholdingConfigs = this.unitWithholdingConfigs.map(unitWithholding => {
      if (unitWithholding.unitToken === unitToken) {
        const updatedUnitWithholding = {
          ...unitWithholding,
          ...updates
        };
        return updatedUnitWithholding;
      }
      return unitWithholding;
    });
    set(this, 'unitWithholdingConfigs', updatedUnitWithholdingConfigs);
  }
  updateApplyBpsToAllLocations(applyBpsToAllLocations) {
    if (!applyBpsToAllLocations && this.accountId) {
      const configs = this.bbFrontendV1WithholdingConfigService.accountWithholdingConfigsMap.get(this.accountId)?.withholdingConfigs;
      if (configs) {
        const mostRecentIds = new Set(getMostRecentConfigs(configs).map(c => c.id));
        this.unitWithholdingConfigs.forEach(config => {
          if (config.id) {
            config.isEnabled = mostRecentIds.has(config.id);
          }
        });
      }
    }
    set(this, 'applyBpsToAllLocations', applyBpsToAllLocations);
  }
  initializeMerchantWithholdingConfig(accountId, withholdingConfig) {
    if (this.features.isEnabled('banking/access_unified_folders')) {
      let setDefaultTarget = true;
      let setDefaultBps = true;
      if (accountId) {
        const config = this.bbFrontendV1WithholdingConfigService.accountWithholdingConfigsMap.get(accountId);
        if (config) {
          if (config.targetAmount) {
            setDefaultTarget = false;
            set(this, 'targetAmount', Money.create({
              amount: config.targetAmount.amount,
              currency: config.targetAmount.currency
            }));
          }
          const configs = config.withholdingConfigs;
          const merchantConfig = configs.find(isMerchantWithholding);
          if (merchantConfig?.withholdingBps) {
            setDefaultBps = false;
            set(this, 'withholdingBps', merchantConfig.withholdingBps);
          }
        }
      }
      if (setDefaultTarget) {
        set(this, 'targetAmount',
        // It's better for this to default to undefined because then the input is empty
        // rather than showing "$0.00". This is how we do it when creating a folder so
        // we should do the same thing for editing or creating a goal.
        undefined);
      }
      if (setDefaultBps) {
        set(this, 'withholdingBps', DEFAULT_WITHHOLDING_BPS);
      }
    } else {
      set(this, 'withholdingBps', withholdingConfig?.withholdingBps || DEFAULT_WITHHOLDING_BPS);
    }
  }
  initializeUnitWithholdingConfigs(accountId) {
    if (!this.features.isEnabled('banking/access_unified_folders')) {
      return;
    }
    // Is this going to accidentally show up for US merchants?
    // Editing
    if (accountId) {
      const configs = this.bbFrontendV1WithholdingConfigService.accountWithholdingConfigsMap.get(accountId)?.withholdingConfigs;

      // Folders/automation/edit-flow (account and configs)
      if (configs && configs.length > 0) {
        const merchantConfig = configs.find(isMerchantWithholding);
        const unitConfigs = configs.filter(isUnitWithholding);
        const unitWithholdingConfigs = this.activeUnits.map(activeUnit => {
          const config = unitConfigs.find(config => config.owner && isUnitWithholding(config) && config.owner.token === activeUnit.token);
          return {
            id: config?.id,
            locationName: activeUnit.nickname,
            unitToken: activeUnit.token,
            isEnabled: config?.isEnabled || false,
            withholdingBps: config?.withholdingBps || DEFAULT_WITHHOLDING_BPS,
            version: config?.version || 0
          };
        });
        set(this, 'applyBpsToAllLocations', Boolean(merchantConfig?.isEnabled));
        set(this, 'unitWithholdingConfigs', unitWithholdingConfigs);
      } else {
        // Folders/automation/create-flow (account but no configs)
        this.setDefaultConfigs();
      }
    } else {
      // Creating entire subaccount (no account and obviously no configs)
      this.setDefaultConfigs();
    }
  }
  setDefaultConfigs() {
    const unitWithholdingConfigs = this.activeUnits.map(activeUnit => {
      return {
        locationName: activeUnit.nickname,
        unitToken: activeUnit.token,
        isEnabled: true,
        withholdingBps: DEFAULT_WITHHOLDING_BPS,
        version: 0
      };
    });
    set(this, 'applyBpsToAllLocations', true);
    set(this, 'unitWithholdingConfigs', unitWithholdingConfigs);
  }
  setCategoryDefaults(category) {
    let accountName;
    let withholdingBps = DEFAULT_WITHHOLDING_BPS;
    if (category === SavingsAccountMetadata.Category.RAINY_DAY) {
      accountName = this.intl.t('banking.savings.subaccounts.create.selectCategory.rainyDay.name');
      withholdingBps = RAINY_DAY_DEFAULT_WITHHOLDING_BPS;
    } else if (category === SavingsAccountMetadata.Category.CUSTOM) {
      accountName = this.intl.t('banking.savings.subaccounts.create.selectCategory.custom.name');
    } else if (category === SavingsAccountMetadata.Category.PAYROLL) {
      accountName = this.intl.t('banking.savings.subaccounts.create.selectCategory.payroll.name');
    } else if (category === SavingsAccountMetadata.Category.RENT) {
      accountName = this.intl.t('banking.savings.subaccounts.create.selectCategory.rent.name');
    } else if (category === SavingsAccountMetadata.Category.TAX) {
      accountName = this.intl.t('banking.savings.subaccounts.create.selectCategory.tax.name');
      withholdingBps = TAX_DEFAULT_WITHHOLDING_BPS;
    } else if (category === SavingsAccountMetadata.Category.EXPENSE) {
      accountName = this.intl.t('banking.savings.subaccounts.create.selectCategory.expense.name');
    } else if (category === SavingsAccountMetadata.Category.RETIREMENT) {
      accountName = this.intl.t('banking.savings.subaccounts.create.selectCategory.retirement.name');
    } else if (category === SavingsAccountMetadata.Category.PROFIT) {
      accountName = this.intl.t('banking.savings.subaccounts.create.selectCategory.profit.name');
    } else if (category === SavingsAccountMetadata.Category.VEHICLE_GAS) {
      accountName = this.intl.t('banking.savings.subaccounts.create.selectCategory.vehicleGas.name');
    } else if (category === SavingsAccountMetadata.Category.GIVING) {
      accountName = this.intl.t('banking.savings.subaccounts.create.selectCategory.giving.name');
    } else if (category === SavingsAccountMetadata.Category.EDUCATION) {
      accountName = this.intl.t('banking.savings.subaccounts.create.selectCategory.education.name');
    } else {
      throw new Error('invalid category');
    }
    if (this.smartFolderRecommendation?.percentageContributionBps !== undefined) {
      withholdingBps = this.smartFolderRecommendation.percentageContributionBps;
    }
    set(this, 'targetAmount', undefined);
    set(this, 'accountName', accountName);
    set(this, 'withholdingBps', withholdingBps);
  }
  resetValues() {
    set(this, 'targetAmount', Money.create({
      amount: 0,
      currency: Currency.USD
    }));
    set(this, 'withholdingBps', DEFAULT_WITHHOLDING_BPS);
    set(this, 'applyBpsToAllLocations', true);
  }
  createSubaccount() {
    if (this.features.isEnabled('banking/access_sfs_savings')) {
      return this.createSavingsAccount();
    }
    return this.createFoldersAccount();
  }
  async createSavingsAccount() {
    const customerId = this.sfsCustomerApi?.currentCustomer?.id;
    if (!customerId) {
      throw new Error('missing sfs customer id');
    }
    set(this, 'idempotencyKey', uuid());
    const account = await this.sfsAccountApi.createAccount(this.idempotencyKey, customerId, this.accountName, this.category);
    if (this.withholdingBps) {
      await this.createWithholdingForAccount(account.bankcBalanceId);
    }
    // TODO: create optional transfer
    return account;
  }
  async createFoldersAccount() {
    set(this, 'idempotencyKey', uuid());
    let account = await this.bbFrontendV1AccountService.createAccount({
      idempotenceKey: this.idempotencyKey,
      name: this.accountName,
      type: AccountType.FOLDERS_ACCOUNT,
      metadata: AccountMetadata.create({
        foldersAccount: FoldersAccountMetadata.create({
          category: this.category
        })
      })
    });
    // TODO: This can be removed once CKG-741 is fixed
    if (!account.availableBalance?.amount) {
      account = Account.create({
        ...account,
        availableBalance: Money.create({
          amount: 0,
          currency: Currency[this.userInfo.currencyCode]
        })
      });
    }
    this.bbFrontendV1AccountService.addToAccounts(account);
    if (this.hasSetWithholdingBps) {
      const accountWithholdingConfig = await this.createAccountWithholdingConfig(account.id);
      if (accountWithholdingConfig) {
        this.bbFrontendV1WithholdingConfigService.addToAccountWithholdingConfigsMap(accountWithholdingConfig);
      }
    }
    return account;
  }
  async updateSubaccount(accountId) {
    const account = this.features.isEnabled('banking/access_sfs_savings') ? await this.sfsAccountApi.updateAccount(accountId, this.accountName) : await this.bbFrontendV1AccountService.updateAccount(accountId, this.accountName);
    return account;
  }
  async createWithholdingForAccount(accountId) {
    if (!this.withholdingBps) {
      throw new Error('Withholding bps is required');
    }
    if (this.targetAmount?.amount === 0) {
      // API expects targetAmount to be undefined in this case
      set(this, 'targetAmount', undefined);
    }
    if (this.targetAmount?.amount && this.targetAmount?.amount > this.maxTargetAmount) {
      throw new Error('Target value is above the maximum allowed');
    }
    const config = WithholdingConfig.create({
      accountId,
      enabled: true,
      targetAmount: this.targetAmount,
      withholdingBps: this.withholdingBps
    });
    const createdConfig = await this.bankingWithholdingConfigApi.create(config);
    return createdConfig;
  }
  async createAccountWithholdingConfig(accountId) {
    if (!this.hasSetWithholdingBps) {
      throw new Error('Withholding config is required');
    }
    if (this.targetAmount?.amount === 0) {
      set(this, 'targetAmount', undefined);
    }
    const withholdingConfigs = [];
    if (this.applyBpsToAllLocations) {
      const merchantWithholdingConfig = BBFrontendWithholdingConfig.create({
        isEnabled: true,
        withholdingBps: this.withholdingBps,
        owner: AccountScopedIdentifier.create({
          type: AccountScopedIdentifier.TokenType.TOKEN_TYPE_MERCHANT,
          token: this.capitalEngineContext.sessionContext.merchantToken
        })
      });
      withholdingConfigs.push(merchantWithholdingConfig);
    } else {
      const unitWithholdingConfigs = this.unitWithholdingConfigs.filter(config => config.isEnabled).map(config => BBFrontendWithholdingConfig.create({
        isEnabled: config.isEnabled,
        withholdingBps: config.withholdingBps,
        owner: AccountScopedIdentifier.create({
          type: AccountScopedIdentifier.TokenType.TOKEN_TYPE_UNIT,
          token: config.unitToken
        })
      }));
      withholdingConfigs.push(...unitWithholdingConfigs);
    }
    const accountWithholdingConfig = CreateWithholdingConfigRequest.create({
      accountId,
      withholdingConfigs,
      targetAmount: this.targetAmount
    });
    const createdConfig = await this.bbFrontendV1WithholdingConfigService.create(accountWithholdingConfig);
    return createdConfig;
  }
  async updateWithholdingConfig({
    withholdingConfig,
    enabled,
    targetAmount,
    withholdingBps
  }) {
    let updatedTarget;
    if (targetAmount?.amount === 0) {
      // API expects targetAmount to be undefined if it's being removed
      updatedTarget = undefined;
    } else {
      updatedTarget = targetAmount ?? withholdingConfig.targetAmount;
    }
    const config = WithholdingConfig.create({
      id: withholdingConfig.id,
      accountId: withholdingConfig.accountId,
      completedAt: withholdingConfig.completedAt,
      // Only update following fields if there are changes passed in
      enabled: enabled ?? withholdingConfig.enabled,
      targetAmount: updatedTarget,
      withholdingBps: withholdingBps ?? withholdingConfig.withholdingBps
    });
    const updatedConfig = await this.bankingWithholdingConfigApi.update(config);
    return updatedConfig;
  }
  async updateAccountWithholdingConfig({
    accountWithholdingConfig
  }) {
    const withholdingConfigs = this.unitWithholdingConfigs.map(config => {
      const owner = AccountScopedIdentifier.create({
        type: AccountScopedIdentifier.TokenType.TOKEN_TYPE_UNIT,
        token: config.unitToken
      });
      return BBFrontendWithholdingConfig.create({
        id: config.id,
        isEnabled: !this.applyBpsToAllLocations && config.isEnabled,
        withholdingBps: config.withholdingBps,
        owner,
        version: config.version
      });
    });

    // We should always have an account id and some configs if we're updating
    if (this.accountId) {
      const configs = this.bbFrontendV1WithholdingConfigService.accountWithholdingConfigsMap.get(this.accountId)?.withholdingConfigs;
      if (configs) {
        const merchantConfig = configs.find(isMerchantWithholding);
        const owner = AccountScopedIdentifier.create({
          type: AccountScopedIdentifier.TokenType.TOKEN_TYPE_MERCHANT,
          token: this.capitalEngineContext.sessionContext.merchantToken
        });
        const withholdingConfig = BBFrontendWithholdingConfig.create({
          id: merchantConfig?.id,
          isEnabled: this.applyBpsToAllLocations,
          withholdingBps: this.withholdingBps,
          owner,
          version: merchantConfig?.version || 0
        });
        withholdingConfigs.push(withholdingConfig);
      }
    }
    const request = UpdateWithholdingConfigRequest.create({
      accountId: accountWithholdingConfig.accountId,
      targetAmount: accountWithholdingConfig.targetAmount,
      withholdingConfigs
    });
    const updatedConfig = await this.bbFrontendV1WithholdingConfigService.update(request);
    return updatedConfig;
  }
  async disableAccountWithholdingConfig({
    accountWithholdingConfig
  }) {
    // We should always have an account id and some configs if we're updating
    if (!this.accountId) {
      throw new Error('Account id must exist when updating an existing config');
    }
    const configs = accountWithholdingConfig.withholdingConfigs;
    const enabledConfigs = configs.filter(c => c.isEnabled);
    // We only want to send enabled configs to backend, otherwise the backend sets effectiveEndAt for all configs which break "autometed contributions" toggle logic
    const updatedConfigs = enabledConfigs.map(c => BBFrontendWithholdingConfig.create({
      ...c,
      isEnabled: false
    }));
    const request = UpdateWithholdingConfigRequest.create({
      accountId: accountWithholdingConfig.accountId,
      targetAmount: accountWithholdingConfig.targetAmount,
      withholdingConfigs: updatedConfigs
    });
    const updatedConfig = await this.bbFrontendV1WithholdingConfigService.update(request);
    this.bbFrontendV1WithholdingConfigService.addToAccountWithholdingConfigsMap(updatedConfig);
    return updatedConfig;
  }
  async updateAccountWithholdingConfigTargetAmount(targetAmount) {
    // We should always have an account id and some configs if we're updating
    if (!this.accountId) {
      throw new Error('Account id must exist in edit flow');
    }
    const configs = this.bbFrontendV1WithholdingConfigService.accountWithholdingConfigsMap.get(this.accountId)?.withholdingConfigs;
    if (!configs?.length) {
      throw new Error('There must be at least 1 withholding config');
    }
    let updatedTargetAmount = targetAmount;
    if (targetAmount?.amount === 0) {
      // API expects targetAmount to be undefined if it's being removed
      updatedTargetAmount = undefined;
    }
    const request = UpdateWithholdingConfigRequest.create({
      accountId: this.accountId,
      targetAmount: updatedTargetAmount,
      // The backend would throw an error if the UI doesn't have the latest configs when updating withholding target
      withholdingConfigs: configs
    });
    const updatedConfig = await this.bbFrontendV1WithholdingConfigService.update(request);
    return updatedConfig;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "bankingAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bankingWithholdingConfigApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1AccountService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1WithholdingConfigService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "locationSelector", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "foldersAccounts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "savingsAccounts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "sfsAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "sfsCustomerApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "smartFolderRecommendationService", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "accountName", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "accountId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "category", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return Category.CUSTOM;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "idempotencyKey", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "maxBps", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return MAX_WITHHOLDING_BPS;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "minBps", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return MIN_WITHHOLDING_BPS;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "shouldAutomationToggleBeOn", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "targetAmount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "maxTargetAmount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return MAX_TARGET_AMOUNT;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "withholdingBps", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return DEFAULT_WITHHOLDING_BPS;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "currentConfigCompleted", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "applyBpsToAllLocations", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "unitWithholdingConfigs", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "currentMaxBps", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "currentMaxBps"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDuplicateNameError", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "showDuplicateNameError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showBlankNameError", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "showBlankNameError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showInvalidNameError", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "showInvalidNameError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enabledUnitWithholdingConfigs", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "enabledUnitWithholdingConfigs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeUnits", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "activeUnits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canSetMultiUnitWithholdingConfig", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "canSetMultiUnitWithholdingConfig"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSetWithholdingBps", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "hasSetWithholdingBps"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unitTokenToTotalBpsMap", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "unitTokenToTotalBpsMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "invalidBpsUnit", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "invalidBpsUnit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWithholdingConfigValid", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "isWithholdingConfigValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "smartFolderRecommendation", [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, "smartFolderRecommendation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "merchantCategoryString", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "merchantCategoryString"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setName", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateName", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateUnitWithholding", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateUnitWithholding"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateApplyBpsToAllLocations", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateApplyBpsToAllLocations"), _class.prototype), _class);
export { AutomationSubaccountState as default };